import COLORS from './colors.json';

const currentColors = {
  ...COLORS,
  attribute__allostatic_load: COLORS['teal'],
  attribute__altitude: COLORS['dark-green'],
  attribute__bike_cadence: COLORS['orange'],
  attribute__bike_power: COLORS['pink'],
  attribute__blood_pressure: COLORS['amber'],
  attribute__body_fat: COLORS['gray'],
  attribute__body_muscle: COLORS['orange'],
  attribute__body_water: COLORS['blue'],
  attribute__body_weight: COLORS['gray'],
  attribute__calories: COLORS['purple'],
  attribute__consistency_index: COLORS['fuchsia'],
  attribute__consumed_calories: COLORS['teal'],
  attribute__core_temperature: COLORS['orange'],
  attribute__distance: COLORS['red'],
  attribute__duration: COLORS['blue'],
  attribute__energy_carbs: COLORS['blue'],
  attribute__energy_fat: COLORS['orange'],
  attribute__energy_protein: COLORS['red'],
  attribute__energy: COLORS['purple'],
  attribute__health_index: COLORS['red'],
  attribute__heart_rate_variability: COLORS['rose'],
  attribute__heart_rate: COLORS.red,
  attribute__heat_strain_index: COLORS['amber'],
  attribute__hrv_pns: COLORS['teal'],
  attribute__hrv_sns: COLORS['orange'],
  attribute__respiration_rate: COLORS['sky'],
  attribute__resting_heart_rate: COLORS['pink'],
  attribute__run_cadence: COLORS['orange'],
  attribute__run_leg_spring_stiffness: COLORS['violet'],
  attribute__run_pace: COLORS['blue'],
  attribute__run_power: COLORS['fuchsia'],
  attribute__run_solid_contact_time: COLORS['emerald'],
  attribute__run_step_length: COLORS['gray'],
  attribute__run_vertical_oscillation_percentage: COLORS['pink'],
  attribute__run_vertical_oscillation: COLORS['pink'],
  attribute__skin_temperature: COLORS['slate'],
  attribute__skin_temperature_deviation: COLORS['slate'],
  attribute__sleep_duration_awake: COLORS['rose'],
  attribute__sleep_duration_deep_sleep: COLORS['sky'],
  attribute__sleep_duration_light_sleep: COLORS['light-blue'],
  attribute__sleep_duration_rem_sleep: COLORS['cyan'],
  attribute__sleep_duration: COLORS['blue'],
  attribute__sleep_score: COLORS['purple'],
  attribute__speed: COLORS['blue'],
  attribute__stress: COLORS['orange'],
  attribute__swim_pace: COLORS['blue'],
  attribute__temperature: COLORS['slate'],
  attribute__training_stress_score: COLORS['teal'],
} as const;

export const APPLICATION_COLORS = currentColors;
